import { useBucket } from '@mc/experiments-react'

import { CAROUSEL_SPRINGBOARD_EXP_FLAG, ExperimentVariants } from './constants'

export const useCarouselSpringboardExp = () => {
  const bucket = useBucket<ExperimentVariants>(CAROUSEL_SPRINGBOARD_EXP_FLAG)

  return {
    inPen4889Experiment: !!bucket,
    isPen4889Variant: bucket === 'variant_1',
  }
}
